/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  
  const roleName = currentUser?.role?.name?.toUpperCase()
  const allowedMenusStr = currentUser?.role?.allowedMenus || ''
  const allowedMenus = allowedMenusStr.split(',').map(m => m.trim())
  const hasAccess = (menuKey: string) => allowedMenus.includes(menuKey)

  // RBAC untuk Activity Log: Admin, Superadmin, dan Client diizinkan
  const canAccessActivityLog =
    hasAccess('activity_log') ||
    roleName === 'ADMIN' ||
    roleName === 'SUPERADMIN' ||
    roleName === 'CLIENT'

  // Periksa apakah ada item di bagian 'System' yang dapat diakses
  const hasSystemSection =
    hasAccess('global_settings') ||
    hasAccess('role_management') ||
    hasAccess('user_management') ||
    canAccessActivityLog

  return (
    <>
      {hasAccess('dashboard') && (
        <SidebarMenuItem
          to='/dashboard'
          icon='element-11'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
        />
      )}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      
      {hasAccess('clients') && (
        <SidebarMenuItem
          to='/clients'
          icon='profile-user'
          title='Clients'
          fontIcon='bi-people'
        />
      )}
      {hasAccess('billing_rates') && (
        <SidebarMenuItem
          to='/billing'
          icon='calculator'
          title='Billing Rates'
          fontIcon='bi-cash'
        />
      )}
      {(hasAccess('products') || hasAccess('billing_rates') || roleName === 'ADMIN' || roleName === 'SUPERADMIN') && (
        <SidebarMenuItem
          to='/products'
          icon='element-plus'
          title='Products & Services'
          fontIcon='bi-box-seam'
        />
      )}
      
      {hasAccess('cdr_report') && (
        <SidebarMenuItem
          to='/cdr'
          icon='graph-up'
          title='CDR Report'
          fontIcon='bi-graph-up'
        />
      )}

      {(hasAccess('data_source') || roleName === 'ADMIN' || roleName === 'SUPERADMIN') && (
        <SidebarMenuItem
          to='/data-sources'
          icon='data'
          title='Data Sources'
          fontIcon='bi-database-gear'
        />
      )}

      {hasAccess('invoice') && (
        <SidebarMenuItem
          to='/invoice'
          icon='document'
          title='Invoices'
          fontIcon='bi-file-text'
        />
      )}
      
      {hasSystemSection && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>System</span>
          </div>
        </div>
      )}

      {canAccessActivityLog && (
        <SidebarMenuItem
          to='/activity-log'
          icon='time'
          title='Activity Log'
          fontIcon='bi-clock-history'
        />
      )}

      {hasAccess('global_settings') && (
        <SidebarMenuItem
          to='/settings'
          icon='setting-2'
          title='Global Settings'
          fontIcon='bi-gear'
        />
      )}

      {hasAccess('role_management') && (
        <SidebarMenuItem
          to='/roles'
          icon='shield-tick'
          title='Role Management'
          fontIcon='bi-shield-lock'
        />
      )}

      {hasAccess('user_management') && (
        <SidebarMenuItem
          to='/users'
          icon='user'
          title='User Management'
          fontIcon='bi-people-fill'
        />
      )}
    </>
  )
}

export {SidebarMenuMain}
